import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

Menu.Item = MenuItem

export default Menu
